const formatterDefinitions = {
	tel: [{

		description: "North America (except Mexico) and Carribbean Islands",
		countries: ["US", "CA", "AS", "AI", "AG", "BB", "BS", "BM", "VI", "VG", "KY", "DM", "DO", "GD", "GU", "MS", "MP", "PR", "KN", "LC", "VC", "JM", "MF", "SX", "TT", "TC"],
		validationRegex: "^\\+1 \\(\\d{3}\\) \\d{3}-\\d{4}$",
		patterns: [
			{ "^1": "+{{9}} ({{999}}) {{999}}-{{9999}}" },
			// No NANP number starts with 0, but nearly every foreign number
			// typed in national format does (UK 020…, DE 030…, AU 04…), as
			// does the US international prefix 011. Leave those as typed
			// rather than truncate them into a wrong +1 number (SC-616).
			{ "^0": "{{*************************}}" },
			{ "*":  "+1 ({{999}}) {{999}}-{{9999}}" }
		]

	}, {

		description: "United Kingdom",
		countries: ["GB"],
		validationRegex: "^\\+44 0?\\d{4} \\d{6}$",
		patterns: [
			{ "^440": "+{{99}} {{99999}} {{999999}}" },
			{ "^44":  "+{{99}} {{9999}} {{999999}}" },
			{ "^4":   "+4{{9}} {{9999}} {{999999}}" },
			{ "^0":   "+44 {{99999}} {{999999}}" },
			{ "*":    "+44 {{9999}} {{999999}}" }
		]

	}, {

		description: "Mexico",
		countries: ["MX"],
		validationRegex: "^\\+52 \\(\\d{2}\\) \\d{4} \\d{4}$",
		patterns: [
		  { "^52":  "+{{99}} ({{99}}) {{9999}} {{9999}}" },
			{ "^5":   "+{{9}}2 ({{99}}) {{9999}} {{9999}}" },
			{ "*":    "+52 ({{99}}) {{9999}} {{9999}}" }
		]

	}, {

		description: "India",
		countries: ["IN"],
		validationRegex: "^\\+91 \\d{2} \\d{4} \\d{4}$",
		patterns: [
		  { "^91":  "+{{99}} {{99}} {{9999}} {{9999}}" },
			{ "^9":   "+{{9}}1 {{99}} {{9999}} {{9999}}" },
			{ "*":    "+91 {{99}} {{9999}} {{9999}}" }
		]
		
	}, {

		description: "South Africa",
		countries: ["ZA"],
		validationRegex: "^\\+27 \\d{2} \\d{3} \\d{4}$",
		patterns: [
		  { "^27":  "+{{99}} {{99}} {{999}} {{9999}}" },
			{ "^2":   "+{{9}}7 {{99}} {{999}} {{9999}}" },
			{ "*":    "+27 {{99}} {{999}} {{9999}}" }
		]
		
	}, {

		description: "Australia",
		countries: ["AU"],
		validationRegex: "^\\+61 \\d{1} \\d{4} \\d{4}$",
		patterns: [
		  { "^61":  "+{{99}} {{9}} {{9999}} {{9999}}" },
			{ "^6":   "+{{9}}1 {{9}} {{9999}} {{9999}}" },
			{ "*":    "+61 {{9}} {{9999}} {{9999}}" }
		]
		
	}, {

		default: true,
		description: "Default",
		validationRegex: "^\\+?[0-9() -]{9,}",
		patterns: [
			{ "*": "{{*************************}}"}
		]

	}]
};

export default formatterDefinitions;
